import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems = [
    {
      question: "Сколько времени занимает разработка проекта?",
      answer: "Время разработки зависит от сложности проекта. Простые лендинги — 2-4 недели, веб-приложения — 2-6 месяцев, сложные платформы — от 6 месяцев. Мы всегда предоставляем детальную оценку после анализа требований."
    },
    {
      question: "Какие гарантии вы даете на свою работу?",
      answer: "Мы предоставляем 6 месяцев бесплатной технической поддержки после сдачи проекта. Также предлагаем гарантию на исправление багов и расширенные пакеты поддержки для долгосрочного сопровождения."
    },
    {
      question: "Работаете ли вы с международными клиентами?",
      answer: "Да, мы активно работаем с клиентами из разных стран. У нас есть опыт реализации проектов для компаний из США, Европы и стран СНГ. Коммуникация ведется на английском и русском языках."
    },
    {
      question: "Можете ли вы взять на поддержку существующий проект?",
      answer: "Конечно! Мы проводим аудит существующего кода, документируем архитектуру и берем проекты на сопровождение. Также можем модернизировать устаревшие решения и добавлять новый функционал."
    },
    {
      question: "Какова стоимость разработки?",
      answer: "Стоимость рассчитывается индивидуально на основе технических требований, сложности и сроков. Лендинги от 150 000₽, веб-приложения от 500 000₽, мобильные приложения от 800 000₽. Предоставляем детальную смету после обсуждения."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-sprintwise-dark mb-6" data-testid="faq-title">
            Часто задаваемые <span className="gradient-text">вопросы</span>
          </h2>
          <p className="text-xl text-gray-600" data-testid="faq-description">
            Ответы на самые популярные вопросы о нашей работе
          </p>
        </div>
        
        <div className="space-y-6">
          {faqItems.map((item, index) => (
            <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-testid={`faq-item-${index}`}>
              <button 
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
                data-testid={`faq-question-${index}`}
              >
                <span className="text-lg font-semibold text-sprintwise-dark">{item.question}</span>
                <ChevronDown 
                  className={`text-gray-400 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`} 
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-gray-600" data-testid={`faq-answer-${index}`}>
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
